import useSWRMutation from 'swr/mutation';
import { putSwrFetcherWithDynamicUrl } from '../../../utils/put-swr-fetcher-with-dynamic-url';

const EXCLUDE_SENDER_URL = '/api/email/connections';

type ExcludeSenderPayload = {
  excludedSenders: string[];
  // Source: https://linear.app/seapoint/issue/TENG-1898/dont-read-invoices-from-this-sender#comment-b0a07ddd
  mode?: 'append' | 'replace';
};

type ExcludeSenderResponse = {
  success: boolean;
  excludedSenders: string[];
  deletedEvidenceIds: string[];
};

export const useExcludeSender = () => {
  const { trigger, isMutating } = useSWRMutation<
    ExcludeSenderResponse,
    Error,
    string,
    ExcludeSenderPayload & { urlSuffix: string }
  >(EXCLUDE_SENDER_URL, putSwrFetcherWithDynamicUrl);

  return {
    excludeSender: trigger,
    isExcludingSender: isMutating,
  };
};
